import { type Tractor } from '../domain/Tractor'

export type RawTractor = {
  uuid?: string
  value: string
  source: string
  carrier: {
    dot_number: string
    mc_number: string
  }
}

export type RawNewTractor = {
  truck_number: string
}

export function mapApiToTractor(tractor: RawTractor): Tractor {
  return {
    tractorNumber: tractor.value,
    tractorNumberSource: tractor.source,
  }
}

export function mapApiToTractors(tractors?: RawTractor[]): Tractor[] {
  return (tractors || []).map(mapApiToTractor)
}

export function mapTractorNumberToApi(tractorNumber: string): RawNewTractor {
  return { truck_number: tractorNumber }
}
